import React from 'react';
import PropTypes from 'prop-types';
import { useBottomScrollListener } from 'react-bottom-scroll-listener';

import Spinner from '../Spinner';
import useFileReactionList from './useFileReactionList';
import AccountReactionItem from './components/AccountReactionItem';

const propTypes = {
  photoId: PropTypes.string,
  videoId: PropTypes.string,
};

const FileReactionList = ({ photoId, videoId }) => {
  const {
    accountReactions,
    accountReactionsTotal,
    loading,
    onLoadMore,
    loadingMore,
  } = useFileReactionList({
    photoId,
    videoId,
  });

  const scrollRef = useBottomScrollListener(() => {
    if (
      accountReactionsTotal > (accountReactions?.length ?? 0) &&
      !loadingMore
    ) {
      onLoadMore();
    }
  }, 200);

  if (loading) {
    return (
      <div className="file-reaction-accounts-wrapper">
        <div className="d-flex justify-content-center align-items-center">
          <Spinner className="m-auto" />
        </div>
      </div>
    );
  }

  return (
    <div className="file-reaction-accounts-wrapper">
      <div className="file-reaction-accounts-list" ref={scrollRef}>
        {accountReactions.map(accountReaction => (
          <AccountReactionItem
            accountReaction={accountReaction}
            key={accountReaction.account_profile.id}
          />
        ))}
        {loadingMore && (
          <div className="w-100 my-2 d-flex">
            <Spinner className="m-auto" />
          </div>
        )}
      </div>
    </div>
  );
};

FileReactionList.propTypes = propTypes;

export default FileReactionList;
